import { DataroomTenant, DATAROOM_TENANTS } from './DataroomTenant';

const dataroomTenantSet = new Set<string>(DATAROOM_TENANTS);

export const isDataroomTenant = (tenant: string): tenant is DataroomTenant => dataroomTenantSet.has(tenant);

export const validateDataroomTenant = (tenant: string | null): void => {
  if (!tenant) {
    throw new Error('Tenant is required to perform dataroom api requests');
  }
  if (!isDataroomTenant(tenant)) {
    throw new Error(`Only dataroom tenants allowed. ${ tenant } provided`);
  }
};
